import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "react-oidc-context"

export function AuthCallback() {
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate("/", { replace: true })
    }
  }, [auth.isAuthenticated, navigate])

  if (auth.error) {
    return (
      <div className="p-5 text-destructive">
        <h2 className="text-lg font-semibold">Authentication Error</h2>
        <p>{auth.error.message}</p>
      </div>
    )
  }

  return (
    <div className="p-5 text-center">
      <p>Completing authentication...</p>
    </div>
  )
}
